import { Component, HostBinding, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

export type FormFieldWidth = 'fill' | 'full' | 'default';

export interface FormFieldErrorConfig {
	key: string;
	show: boolean;
	text?: string;
	params?: Record<string, string | number>;
}

@Component({
	selector: 'app-form-field',
	standalone: true,
	imports: [TranslateModule, NgClass, NgbPopover],
	templateUrl: './form-field.component.html',
	styleUrls: ['./form-field.component.scss', './form-field.responsive.scss'],
})
export class FormFieldComponent {
	id = input<string>('');
	label = input<string>('');
	tooltip = input<string>('');
	fieldClass = input<string>('');
	width = input<FormFieldWidth>('default');

	required = input<boolean>(true);
	errors = input<FormFieldErrorConfig[] | null>();

	@HostBinding('class')
	get widthClasses() {
		return {
			'width-full': this.width() === 'full',
			'width-fill': this.width() === 'fill',
		};
	}

	protected getErrorParams(config: FormFieldErrorConfig): Record<string, any> {
		return { label: this.label(), ...config.params };
	}
}
